import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import { PersonalInfoFormStepTwo } from "app/utils/applicant/types/types";
import DynamicFormTwo from "app/components/Individual/applicant/personalDetails/DynamicFormTwo";

const PersonalDetailsPartTwo: React.FC = () => {
  const dispatch = useDispatch();

  const { applicants, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    clearErrors,
  } = useForm<PersonalInfoFormStepTwo>({
    defaultValues: {
      numberOfDependents: 0,
    },
  });

  const onSubmit = (data: PersonalInfoFormStepTwo) => {
    const { numberOfDependents, maritalStatus, address, housingStatus } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        applicants: {
          ...applicants,
          numberOfDependents: Number(numberOfDependents),
          maritalStatus: maritalStatus,
          mailingAddress: {
            housingStatus,
          },
          address: {
            street: address.street,
            state: address.state,
            postCode: address.postCode,
          },
        },
      })
    );
    dispatch(nextStep());
  };

  useEffect(() => {
    if (applicants) {
      reset({
        ...(applicants.numberOfDependents && {
          numberOfDependents: Number(applicants.numberOfDependents),
        }),
        maritalStatus: applicants.maritalStatus,
        ...(applicants.mailingAddress && {
          housingStatus: applicants?.mailingAddress?.housingStatus || "",
        }),
        address: {
          street: applicants?.address?.street,
          state: applicants?.address?.state,
          postCode: applicants?.address?.postCode,
        },
      });
    }
  }, [applicants, reset]);

  return (
    <>
      <ProgressBar progress={70} />
      <div className="w-full  sm:w-[70%] xl:w-[45%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Personal Details" />
        <SubTitle title="Please enter the required information below" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <DynamicFormTwo
            control={control}
            errors={errors}
            register={register}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            numberDependentsName="numberOfDependents"
            maritalStatusName="maritalStatus"
            housingStatusName="housingStatus"
            addressStreetName="address.street"
            addressStateName="address.state"
            addressPostCodeName="address.postCode"
          />
          <div className="flex justify-between my-10">
            <PreviousButtom onClick={() => dispatch(prevStep())}>
              Previous
            </PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PersonalDetailsPartTwo;
